import * as React from 'react';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { ParameterField } from './ParameterField';
import SelectField from './SelectField';

const DEFAULT_QUERY_ROOT_ENTITY = 'default';

export function QueryRootEntityField(props: {
    value?: string;
    entitites?: string[];
    dataSourceID?: number;
    glob?: IGlob;

    onChange?(value: string): void;
}) {
    const options = {
        values: [DEFAULT_QUERY_ROOT_ENTITY]
    }

    if (props.entitites != null) {
        options.values.push(...props.entitites);
    }
    else if (props.dataSourceID != null) {
        const entities = props.glob.EntityModelsStore.getEntitiesTreeByDS(props.dataSourceID);

        if (entities != null) {
            entities.forEach(entity => {
                options.values.push(entity.name);
            });
        }
    }

    return (
        <ParameterField
            className="query-root-entity"
            title={ 'Query Root Entity' }
            clearable={ false }
        >
            <SelectField
                value={ props.value || DEFAULT_QUERY_ROOT_ENTITY }
                allowNull={ false }
                options={ options }
                onChange={ value => {
                    if (value === DEFAULT_QUERY_ROOT_ENTITY) {
                        value = null;
                    }

                    if (props.onChange != null) {
                        props.onChange(value);
                    }
                } }
            />
        </ParameterField>
    );
}

